/**
 * Offer detail pages show the booking flow inline in the sidebar (instead of a
 * single CTA that opens BookingModal) on these hostnames.
 */
const INLINE_BOOKING_HOSTS = new Set([
  'dev.wownautic.com',
  'wownautic.com',
  'www.wownautic.com',
]);

export function isOfferInlineBookingHost() {
  if (typeof window === 'undefined') return false;
  return INLINE_BOOKING_HOSTS.has(window.location.hostname.toLowerCase());
}
